import CustomerType from '../sso/CustomerType';
import { Segment, SEGMENT_ARI, SEGMENT_ERA, SEGMENT_PRIVATE } from '../stores/SegmentStore';

export const getCustomerType = (currentSegment: Segment): CustomerType => {
  return currentSegment === SEGMENT_PRIVATE ? CustomerType.B2C : CustomerType.B2B;
};

export const getCustomerPathSegment = (currentSegment: Segment): 'era' | 'ari' => {
  return currentSegment === SEGMENT_PRIVATE ? SEGMENT_ERA : SEGMENT_ARI;
};
